/**
 * WaveDivider — animated SVG wave that sits between sections.
 * Use placement="top" to cut a wave INTO the top of a section,
 * placement="bottom" to flow the section into a wave below it.
 */
export default function WaveDivider({
  placement = "top",
  fromColor = "#ffffff",
  className = "",
  height = 80,
  animated = true,
}) {
  const transform = placement === "top" ? "" : "scale(1, -1) translate(0, -100)";
  return (
    <div
      aria-hidden
      className={`pointer-events-none w-full overflow-hidden leading-[0] ${className}`}
      style={{ height }}
    >
      <svg
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        className="w-full h-full block"
      >
        <g transform={transform}>
          {animated ? (
            <path fill={fromColor}>
              <animate
                attributeName="d"
                dur="9s"
                repeatCount="indefinite"
                values="
                  M0 0 C 240 90 480 10 720 50 C 960 90 1200 10 1440 50 L 1440 0 Z;
                  M0 0 C 240 30 480 90 720 40 C 960 10 1200 90 1440 30 L 1440 0 Z;
                  M0 0 C 240 90 480 10 720 50 C 960 90 1200 10 1440 50 L 1440 0 Z
                "
              />
            </path>
          ) : (
            <path
              fill={fromColor}
              d="M0 0 C 240 90 480 10 720 50 C 960 90 1200 10 1440 50 L 1440 0 Z"
            />
          )}
        </g>
      </svg>
    </div>
  );
}
